/**
 * Component: Browsing Context
 * -----------------------------------------------------------------------------
 * Get browsing context for country selector
 *
 */
// eslint-disable-next-line import/no-unresolved
import Cookies from 'js-cookie'

/**
* Export browsing context.
*/
export default () => {
  const localizedDismissed = Cookies.get('localizedDismissed')

  /**
  * Initialise component.
  */
  function init() {
    if (localizedDismissed && typeof localizedDismissed === 'string') {
      compareCookieDomain()
      return
    }

    setEventListeners()
  }

  /**
  * Check if the saved cookie domain is different from the current store domain
  */
  function compareCookieDomain() {
    const cookieSplit = localizedDismissed.split('-')
    const cookieDomain = cookieSplit[1]
    const currentDomain = cnvs.store.country.toLowerCase()

    if (currentDomain !== cookieDomain) {
      setEventListeners()
    }
  }

  /**
  * Set the event listener
  */
  function setEventListeners() {
    cnvs.EventBus.listen('cnvs:locationToggleReady', () => getBrowsingContect())
    cnvs.EventBus.emit('cnvs:locationToggleListenerReady')
  }

  /**
  * Get browsing context
  */
  async function getBrowsingContect() {
    const response = await fetch('/browsing_context_suggestions.json')

    if (!response) {
      return
    }

    const browserContext = await response.json()

    window.cnvs.strings.defaultLocalization.detected_values = {
      country: browserContext.detected_values.country,
    }

    if (browserContext.detected_values.country.handle !== cnvs.store.country) {
      cnvs.EventBus.emit('browser-context', browserContext)
    }
  }

  /**
  * Expose public interface.
  */
  return Object.freeze({
    init,
  })
}
